import { render, staticRenderFns } from "./ExpertWorksheet.vue?vue&type=template&id=ae543b42&"
import script from "./ExpertWorksheet.vue?vue&type=script&lang=js&"
export * from "./ExpertWorksheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports